import { createSelector } from '@reduxjs/toolkit'
import { denormalize, normalize } from 'normalizr'
import { useSelector } from 'react-redux'
import { get } from 'lodash'
import api from '../../api'
import config from '../../config'
import { ordersSchema } from '../normalizr'
import { getPaginationHeaders, useAsyncAction } from '../utils'
import createSlice from '../create-slice'
import { getEntities } from './entities'

const ordersInitialState = {
  cycles: {},
}

const ordersSlice = createSlice({
  name: 'orders',
  initialState: ordersInitialState,
  reducers: {
    setOrders: (
      state,
      { payload: { entities, result, params, total }, payload },
    ) => {
      const queryKey = JSON.stringify(params)

      state.orders = state.orders || {}
      state.orders[queryKey] = {
        ids: result,
        total,
      }
    },
  },
})

const { actions } = ordersSlice

const selectState = state => {
  return state[ordersSlice.name]
}

function getOrderUrl({ filePath }) {
  if (!filePath) return null
  const path = filePath.startsWith('/') ? filePath : `/${filePath}`
  return `${config.apiUrl}${path}`
}

const selectOrders = createSelector(
  selectState,
  getEntities,
  (state, params) => params,
  (state, entities, params) => {
    const queryKey = JSON.stringify(params)

    const resp = {
      orders: denormalize(
        get(state.orders, [queryKey, 'ids'], []),
        [ordersSchema],
        entities,
      ).map(order => {
        return {
          ...order,
          url: getOrderUrl(order),
        }
      }),
      total: get(state.orders, [queryKey, 'total'], 0),
    }

    return resp
  },
)

export function useOrders(params) {
  return useSelector(state => selectOrders(state, params))
}

function fetchOrders(params) {
  return async dispatch => {
    const { body, headers } = await api.orders.list(params)

    return dispatch(
      actions.setOrders({
        params,
        ...normalize(body, [ordersSchema]),
        ...getPaginationHeaders(headers),
      }),
    )
  }
}

export function useFetchOrders(conditions) {
  return useAsyncAction(fetchOrders, conditions)
}

export default ordersSlice
